<main>
  <loading-overlay [isLoading]="isLoading() > 0"></loading-overlay>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'Requisitions_Title' | translateWF: 'Production Requisitions' }}</h1>
        @if (canEdit()) {
          <div class="page__title_buttons">
            <p-button [label]="'Common_Add' | translateWF: 'Add'" icon="pi pi-plus" iconPos="left" (click)="redirectToDetail()" />
          </div>
        }
      </div>
    </div>

    <div class="cs-page-list-grid">
      <!-- Filters Panel -->
      @if (filterConfig() && showFilters()) {
        <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="filterState" />
      }

      <!-- Data Table Panel -->
      <p-panel [header]="'Requisitions' | translateWF: 'Requisitions'">
        <ng-template pTemplate="icons">
          <p-button
            [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
            [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
            (click)="showFilters.set(!showFilters())"
            variant="outlined"
            size="small"
          />
        </ng-template>
        <p-card data-variant="compact">
          <p-table [value]="requisitions()" selectionMode="single">
            <ng-template pTemplate="header">
              <tr>
                <th>{{ 'Requisition_Number' | translateWF: 'Requisition Number' }}</th>
                <th>{{ 'Production_Work_Order' | translateWF: 'Production Work Order' }}</th>
                <th>{{ 'Status' | translateWF: 'Status' }}</th>
                <th>{{ 'Created_Date' | translateWF: 'Created Date' }}</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData>
              @let requisition = getRowData(rowData);
              <tr class="cursor-pointer" (click)="redirectToDetail(requisition.id)">
                <td>
                  <a>{{ requisition.requisitionNumber }}</a>
                </td>
                <td>{{ requisition.initiatorNumber }}</td>
                <td>{{ requisitionStatus()[requisition.status] }}</td>
                <td>{{ requisition.createdDate | date: 'dd/MM/yyyy' }}</td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="4">
                  {{ 'Requisitions_Not_Found' | translateWF: 'No Requisitions Found' }}
                </td>
              </tr>
            </ng-template>
          </p-table>

          <p-paginator
            [rows]="pageSize"
            [totalRecords]="totalRecords"
            [first]="(currentPage - 1) * pageSize"
            (onPageChange)="onPageChange($event)"
            [rowsPerPageOptions]="[10, 25, 50, 100]"
            class="mt-4"
          ></p-paginator>
        </p-card>
      </p-panel>
    </div>
  </div>
</main>
